import { createAction, props } from "@ngrx/store";
import { ProposalReceipt, ProposalReceiptSummary } from "app/entities";

export const loadProposalReceipts = createAction(
    '[Proposal Receipt] Load',
    props<{ proposalId: number }>()
);

export const loadProposalReceiptsSuccess = createAction(
    '[Proposal Receipt] Load Success',
    props<{ proposalId: number, receipts: ProposalReceipt[], summary: ProposalReceiptSummary }>()
);

export const loadProposalReceiptsFailure = createAction(
    '[Proposal Receipt] Load Failure',
    props<{ error: any }>()
);

export const clearProposalReceipts = createAction(
    '[Proposal Receipt] Clear'
);

export const createProposalReceipt = createAction(
    '[Proposal Receipt] Create',
    props<{ proposalId: number, data: any }>()
);

export const createProposalReceiptSuccess = createAction(
    '[Proposal Receipt] Create Success',
    props<{ proposalId: number, receipt: ProposalReceipt }>()
);

export const createProposalReceiptFailure = createAction(
    '[Proposal Receipt] Create Failure',
    props<{ error: any }>()
);

export const updateProposalReceipt = createAction(
    '[Proposal Receipt] Update',
    props<{ proposalId: number, receiptId: number, data: any }>()
);

export const updateProposalReceiptSuccess = createAction(
    '[Proposal Receipt] Update Success',
    props<{ proposalId: number, receipt: ProposalReceipt }>()
);

export const updateProposalReceiptFailure = createAction(
    '[Proposal Receipt] Update Failure',
    props<{ error: any }>()
);

export const deleteProposalReceipt = createAction(
    '[Proposal Receipt] Delete',
    props<{ proposalId: number, receiptId: number }>()
);

export const deleteProposalReceiptSuccess = createAction(
    '[Proposal Receipt] Delete Success',
    props<{ proposalId: number, receiptId: number }>()
);

export const deleteProposalReceiptFailure = createAction(
    '[Proposal Receipt] Delete Failure',
    props<{ error: any }>()
);
